import axios from "axios";

export const LOGIN_URL = "api/auth/login";
export const REGISTER_URL = "api/auth/register";
export const VALIDATE_TOKEN_URL = "api/auth/validate-token";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const RESET_PASSWORD_URL = "api/auth/reset-password";
export const ME_URL = "api/me";
export const SIMULATE_URL = "api/simulate";

const API_URL = "https://graphql.brandsolo.com/v1/graphql";
export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}
export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}
export function validateToken(token) {
  return axios.post(VALIDATE_TOKEN_URL, { token });
}
export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}
export function resetPassword(password, token) {
  return axios.post(RESET_PASSWORD_URL, { password, token });
}
export function getUserByToken() {
  return axios.get(ME_URL);
}
export function getUserById(id) {
  return axios.get(SIMULATE_URL, { params: id });
}

